/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_GenerateInputs */

const en_tts_tool_generate = /** @type {(inputs: Tts_Tool_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate audio`)
};

const es_tts_tool_generate = /** @type {(inputs: Tts_Tool_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar audio`)
};

/**
* | output |
* | --- |
* | "Generate audio" |
*
* @param {Tts_Tool_GenerateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_generate = /** @type {((inputs?: Tts_Tool_GenerateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_GenerateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_generate(inputs)
	return en_tts_tool_generate(inputs)
});